import api from './api';
import { DistributionRedemption, DistributionRedemptionVoucher, Response } from '../dtos';

const getDistributionRedemption = async (hash: String): Promise<DistributionRedemption | null> => {
    const { data } = await api.get<Response<DistributionRedemption | undefined>>(`distribution/redemption/${hash}`);
    return data.data || null;
};

const getDistributionRedemptionVouchers = async (hash: String): Promise<DistributionRedemptionVoucher[]> => {
    const { data } = await api.post<Response<DistributionRedemptionVoucher[]>>(`distribution/redemption/${hash}`);
    return data.data;
};

export { getDistributionRedemption, getDistributionRedemptionVouchers };